// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"32f4e085","433":"188a9883"}[chunkId] + ".chunk.js";
};